import React from 'react'

interface Props {
  hasPrev:  boolean
  hasNext:  boolean
  onPrev:   () => void
  onNext:   () => void
  loading?: boolean
}

const CommissionRulesCursorNav: React.FC<Props> = ({ hasPrev, hasNext, onPrev, onNext, loading }) => (
  <div className='d-flex justify-content-end gap-2 mt-3'>
    <button type='button' className='btn btn-sm btn-light' disabled={!hasPrev || loading} onClick={onPrev}>
      &lt; Назад
    </button>
    <button type='button' className='btn btn-sm btn-light' disabled={!hasNext || loading} onClick={onNext}>
      Далее &gt;
    </button>
  </div>
)

export default CommissionRulesCursorNav
